const translations = {
  "en": {
    "How does this event affect stocks and crypto today?": "How does this event affect stocks and crypto today?",
    "How should I interpret this news for my portfolio?": "How should I interpret this news for my portfolio?",
    "Is this a short-term reaction or a longer trend?": "Is this a short-term reaction or a longer trend?",
    "Market Summary": "Market Summary",
    "What are the key signals hidden behind this news?": "What are the key signals hidden behind this news?",
    "What are the upside and downside cases from this?": "What are the upside and downside cases from this?",
    "What should I focus on in this news?": "What should I focus on in this news?",
    "What's the most important thing I should take from this?": "What's the most important thing I should take from this?"
  },
  "zh-tw": {
    "How does this event affect stocks and crypto today?": "這個事件對今天的股票和加密貨幣有何影響？",
    "How should I interpret this news for my portfolio?": "我應如何解讀這則新聞對我的投資組合的影響？",
    "Is this a short-term reaction or a longer trend?": "這是短期反應還是長期趨勢？",
    "Market Summary": "市場摘要",
    "What are the key signals hidden behind this news?": "這則新聞背後有哪些關鍵信號？",
    "What are the upside and downside cases from this?": "從這一點來看，上行和下行的情況是什麼？",
    "What should I focus on in this news?": "我應該關注這則新聞的什麼內容？",
    "What's the most important thing I should take from this?": "我應該從中吸取的最重要的一點是什麼？"
  }
};

export default translations;
